import { UseQueryOptions } from "@tanstack/react-query"

export const DEFAULT_STALE_TIME = 1000 * 60 * 60 * 1 // 1 hour
export const DEFAULT_GC_TIME = 1000 * 60 * 60 * 2 // 2 hours

export const QUICK_STALE_TIME = 60_000 // 1 minute
export const QUICK_GC_TIME = 5 * 60_000 // 5 minutes

export const MEDIUM_STALE_TIME = 300_000 // 5 minutes
export const MEDIUM_GC_TIME = 600_000 // 10 minutes

export const createQueryConfig = <TData, TError>(
	options: Partial<UseQueryOptions<TData, TError>> = {}
): Partial<UseQueryOptions<TData, TError>> => ({
	staleTime: DEFAULT_STALE_TIME,
	gcTime: DEFAULT_GC_TIME,
	refetchOnWindowFocus: false,
	refetchOnMount: false,
	...options
})

export const createShortLivedQueryConfig = <TData, TError>(
	options: Partial<UseQueryOptions<TData, TError>> = {}
): Partial<UseQueryOptions<TData, TError>> => ({
	staleTime: 1000 * 60 * 5, // 5 minutes
	gcTime: 1000 * 60 * 10, // 10 minutes
	refetchOnWindowFocus: false,
	refetchOnMount: false,
	...options
})
